<template>
	<div class="row cc-info">
		<div class="col-lg-7">
			<div>
				<div class="row">
					<div class="col-sm-12">
						<div class="form-group">
							<label for="card-number">
								Credit/Debit Card Number
								<small v-if="showRequiredLabel"><span class="redText">required </span></small>
							</label>
							<div class="form-control" id="card-number"/>
						</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-sm-6">
						<div class="form-group">
							<label for="card-expiry">
								Expiration
								<small v-if="showRequiredLabel"><span class="redText">required </span></small>
							</label>
							<div class="form-control" id="card-expiry"/>
						</div>
					</div>
					<div class="col-sm-6">
						<div class="form-group">
							<label for="card-cvc">
								CVC
								<small v-if="showRequiredLabel"><span class="redText">required </span></small>
							</label>
							<div class="form-control" id="card-cvc"/>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-12">
						<ac-address v-model="vm.billingAddress"></ac-address>
					</div>
				</div>
				<div class="row" v-if="askToDefault">
					<div class="col-sm-7">
						<p>Set as new default card:</p>
					</div>
					<div class="col-sm-5">
						<div class="switch">
							<label>
								No
								<input type="checkbox" v-model=isNewDefault>
								<span class="lever"></span> Yes
							</label>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="col-lg-5">
			<small style="font-style: italic">
				I authorize this business party to charge the credit/debit card indicated above.
				I understand that this authorization will remain in effect until I cancel in writing, and I agree to notify
				in writing of any changes in my account information or termination of this authorization at least 30 days
				prior to the next billing cycle (1st of the month). This payment authorization is for the type of bill indicated above.
				I certify that I am an authorized user of this credit/debit card and that I will not dispute the scheduled payment with my
				credit/debit card company provided the transactions correspond to the terms indicated in this authorization form.
			</small>
		</div>
	</div>
</template>

<script>
	import {common} from "../../global/common.js";
	import {notifications} from "../../global/notifications.js";
	import _ from "lodash";
	import {configTables} from "../../global/configTables.js";
	import AcAddress from "./AcAddress.vue";

	let stripe = Stripe(common.APP_CONFIG.STRIPE_PK);
	export default {
		name: "AcCreditCard",
		components: {AcAddress},
		props: {
			value: {type: Object, required: true},
            showRequiredLabel: {type: Boolean, default: false},
			askToDefault: {type: Boolean, default: false}
		},
		data() {
			return {
				cardNumber: {},
				cardExpiry: {},
				cardCvc: '',
				vm: {...this.value},
				cardElement: {},
				isNewDefault: false
			};
		},
		watch: {
			vm: {
				deep: true,
				handler(value) {
					this.$emit('input', value);
				}
			},
		},
		mounted() {
			const elements = stripe.elements();

			this.cardNumber = elements.create('cardNumber', {});
			this.cardExpiry = elements.create('cardExpiry', {});
			this.cardCvc = elements.create('cardCvc', {});

			this.cardNumber.mount('#card-number');
			this.cardExpiry.mount('#card-expiry');
			this.cardCvc.mount('#card-cvc');
		},
		methods: {
			async getPaymentMethodId() {
				let states = await configTables.getStates();
				let match = _.find(states, (state) => {
					return state.stateProvinceId === this.vm.billingAddress.stateProvinceId;
				});

				const { paymentMethod, error } = await stripe.createPaymentMethod({
                    type: 'card',
                    card: this.cardNumber,

					billing_details: {
						address: {
							line1: this.vm.billingAddress.address1 || '',
							line2: this.vm.billingAddress.address2 || '',
							city: this.vm.billingAddress.city || '',
							state: this.hasValue(match) ? match.stateProvinceCode : '',
							postal_code: this.vm.billingAddress.zipCode || '',
							country: 'US'
						}
					}
                });

				if (error) {					
					notifications.show({
						title: "Invalid Credit/Debit Card Information",
						message: error.message
					},	common.ACRESSA_NOTIFICATIONS.ERROR);
					return null;
				} else {
					return paymentMethod.id;
				}
			},
			async getNewDefaultBool(){
				return this.isNewDefault;
			}

		}
	}
</script>

<style scoped>

</style>